import { Product } from '@commerce/types'
import { getCurrencyCountryCode, normalizeAlgoliaHit } from '@commerce/utils'
import { ProductCard } from '@components/product'
import { useRouter } from 'next/router'
import { FC } from 'react'

interface Props {
  hit: any
  variant: any
  mode: any
  smallestCard?: boolean
  sendEvent?: any
}

const AlgoliaHit: FC<Props> = ({
  hit,
  variant,
  mode,
  smallestCard,
  sendEvent,
}) => {
  const { locale } = useRouter()
  const currencyCode = getCurrencyCountryCode(locale)
  const product: Product.Product = normalizeAlgoliaHit(hit, currencyCode)

  return (
    <ProductCard
      hit={hit}
      key={product.id}
      id={product.id}
      handle={product?.handle}
      name={product?.name}
      type={product?.productType}
      mode={mode}
      popular={product.popular}
      imageAlt={product.name}
      imageUrl={product?.product_image} //To match the product image to thumbnail
      colourCode={product?.colourCode}
      variant={variant}
      colourCardHandle={product?.colourCardHandle}
      showQuickAddButton
      showWishListButton
      path={product.path}
      smallestCard={smallestCard ? smallestCard : false}
      sendEvent={sendEvent}
    />
  )
}

export default AlgoliaHit
